export default __webpack_public_path__ + "static/media/addLanguagePlus.d0a71c55.svg";